
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game-reviews",
      function () {
        return require("private-next-pages/game-reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game-reviews"])
      });
    }
  